import { CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, TextField, Tooltip } from "@material-ui/core"
import { Archive, Cancel, RemoveCircle } from "@material-ui/icons"
import { useState } from "react"
import { Button, useNotify } from "react-admin"
import { Spacer } from "../../components/spacer"
import dataProvider from "../../providers/data-provider"


export const FinishActivityButton = ({ school_activity, ...props }) => {

    const notify = useNotify()

    const [loading, setLoading] = useState(false)
    const [val, setVal] = useState('')
    const [valid, setValid] = useState(false)
    const [open, setOpen] = useState(false)

    const handleOpen = () => setOpen(true)
    const handleClose = () => setOpen(false)

    const handleFinalizeActivity = () => {
        dataProvider.post('school-activities', `${school_activity.id}/finish`, { has_finished: false })
            .then(() => { notify('Atividade finalizada com sucesso', 'success') })
            .catch(() => { notify('Erro ao finalizar atividade', 'error') })
            .finally(() => { setLoading(false); setVal(''); setValid(false); handleClose() })
    }

    const handleClick = () => { setLoading(true); handleFinalizeActivity() }

    const onChange = (event) => {
        const newVal = event.target.value.toUpperCase();
        if (newVal === 'FINALIZAR') {
            setValid(true)
        } else {
            setValid(false)
        }; setVal(newVal)
    }


    return (
        <>
            <Tooltip title="Encerrar atividade">
                <IconButton onClick={handleOpen}>
                    <RemoveCircle />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose}>
                <DialogTitle>{`Aviso!`}</DialogTitle>
                <DialogContent>
                    <DialogContentText>{`Ao finalizar esta atividade prática, esta será tida como finalizada e todas as movimentações de todos os seus processos serão marcadas como corrigidas e seus prazos não serão mais rastreados no dashboard do professor.`}</DialogContentText>
                    <DialogContentText>{`Para prosseguir com esta ação, digite "FINALIZAR" no campo de texto abaixo.`}</DialogContentText>
                    <TextField variant="filled" label={'Confirmação'} value={val} onChange={onChange} fullWidth />
                </DialogContent>
                <DialogActions>
                    <Button label="Cancelar" variant="contained" onClick={handleClose} disabled={loading}><Cancel /></Button>
                    <Spacer />
                    <Button label="Prosseguir" variant="outlined" onClick={handleClick} disabled={loading || !valid}>{loading ? <CircularProgress size={16} /> : <Archive />}</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}